import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// mui
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import { Stack, Typography } from '@mui/material';
// component
import TopBackButton from '@/component/common/top-back-button';
import UserInfo from '@/component/common/user-info';
import SFBottomNavigation from '@/component/common/sf-bottom-navigator';
import SFAccordion from '@/component/common/sf-accordion';
import Loading from '@/component/mui/Backdrop';
// import NFTDetail from '@/component/nft/Detail';
import ShowTaycanEvmscanDrawer from '@/component/nft/ShowTaycanEvmscanDrawer';
import CollectionList from '@/component/nft/CollectionList';
import BottomFix from '@/component/common/bottom-fix';
import { combineName } from '@/component/nft/collect';
import SFWarningIcon from '@/component/icons/sf-warning-icon';
import { OwnedNft, OwnedNftsResponse } from 'alchemy-sdk';
// api
import { myCollectionList, nftDataRes, ownCollection } from '@/api/server/nft/collections';
// lib
import { SFPalette } from '@/lib/color';
import { useWeb3 } from '@/hooks/use-web3';

function EmptyNFT() {
  const { t } = useTranslation();
  return (
    <Box>
      <Stack alignItems="center" mb={2.5}>
        <SFWarningIcon />
      </Stack>
      <Typography variant="body2" color={SFPalette.grey2} textAlign="center" mb={3} fontWeight={500}>
        {t('message.noNftPossession')}
      </Typography>
    </Box>
  );
}

export default function NftMain() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isTaycanEvmscanDrawer, setIsTaycanEvmscanDrawer] = useState(false);
  const [nftList, setNftList] = useState<OwnedNft[]>([]);
  const [allNftList, setAllNftList] = useState<OwnedNft[]>([]);
  const [selectNft, setSelectNft] = useState<OwnedNft | null>(null);
  const [isCollection, setIsCollection] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const isFindNftList = useRef(false);

  const { web3authCall } = useWeb3();
  useEffect(() => {
    (async () => {
      if (web3authCall?.connected() && isFindNftList.current === false) {
        const address = await web3authCall.getAddress();
        try {
          const re = await web3authCall.getAlchemy().nftsOwner(address);
          setAllNftList(re.ownedNfts);
          if (!re.ownedNfts.length) {
            isFindNftList.current = true;
            setIsLoading(false);
            return;
          }
          const res = combineName(re.ownedNfts);

          setNftList(res);
          setIsLoading(false);
          isFindNftList.current = true;
        } catch (e) {
          setIsLoading(false);
        }
      }
    })();
    return () => {};
  }, [allNftList, web3authCall]);

  // useEffect(() => {
  //   if (!address) {
  //     toast.error(`${t('title.walletConnect')}`);
  //     return;
  //   }
  //   (async () => {
  //     const {
  //       data: { nfts, status: nftStatus },
  //       status,
  //     } = await ownCollection({ address });
  //     console.log(`allCollections`);
  //     if (status !== 200 || nftStatus !== 200) {
  //       return;
  //     }
  //     if (nfts.length === 0) {
  //       return t('validation.nftEmpty');
  //     }
  //     // console.log(nfts);
  //     setAllNftList(nfts);
  //     const re = myCollectionList(nfts);
  //     setNftList(re);
  //   })();
  //   return () => {};
  // }, [navigate, address]);

  useEffect(() => {
    if (isCollection) {
      navigate('/nftDetail', {
        state: {
          contract: selectNft!.contract.address,
          tokenId: String(selectNft!.tokenId),
        },
      });
    }

    return () => {};
  }, [isCollection]);

  return (
    <Box>
      <Container
        maxWidth="sm"
        sx={{
          minHeight: 812,
          position: 'relative',
        }}
      >
        {/* <TopBackButton
          title="NFT"
          rightItem={
            <IconButton
              onClick={() => {
                setIsTaycanEvmscanDrawer(true);
              }}
            >
              <MoreHorizIcon />
            </IconButton>
          }
          boxProps={{
            mb: 4,
          }}
          backPath="/wallet"
        /> */}
        <Box mb={4}>
          <UserInfo colorTone="black" />
        </Box>
        <Divider />
        {isLoading ? (
          <Loading isLoading={isLoading} />
        ) : (
          <div>
            {nftList.length === 0 ? (
              <Box mt={10}>
                <EmptyNFT />
              </Box>
            ) : (
              <Box>
                {/* <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="body1" fontWeight={500} color={SFPalette.grey4}>
                <Button
                  onClick={() => {
                    navigate('/sendNft');
                  }}
                >
                  nft 전송
                </Button>
              </Typography>
            </Stack> */}
                {/* TODO 고도화: 첫 번째 collection만 펼쳐 보이게 */}
                {nftList.map((item: OwnedNft, index: number) => {
                  return (
                    <Box key={`collection-${index}-${item.contract.name}`}>
                      <SFAccordion
                        header={item.contract.name}
                        accordionDetailsProps={{
                          sx: {
                            p: 0,
                          },
                        }}
                      >
                        <Box mb={3}>
                          <CollectionList
                            contract={item.contract.address}
                            allNftList={allNftList}
                            setSelectNft={setSelectNft}
                            setIsCollection={setIsCollection}
                          />
                        </Box>
                      </SFAccordion>
                      <Divider />
                    </Box>
                  );
                })}
              </Box>
            )}
          </div>
        )}
        {/* {isCollection && (
          <NFTDetail
            open={isCollection}
            onClose={() => {
              setIsCollection(false);
            }}
            contract={selectNft!.contract.address}
            tokenId={String(selectNft!.tokenId)}
          />
        )} */}
      </Container>
      <BottomFix enableHeight={false}>
        <SFBottomNavigation selectedLabel={t('button.wallet')} />
      </BottomFix>

      {isTaycanEvmscanDrawer && (
        <ShowTaycanEvmscanDrawer
          open={isTaycanEvmscanDrawer}
          onClose={() => {
            setIsTaycanEvmscanDrawer(false);
          }}
        />
      )}
    </Box>
  );
}
